import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["errorRow", "toggleButton", "chevron"]

  connect() {
    this.errorRowTarget.classList.add("hidden")
  }

  toggle() {
    const isHidden = this.errorRowTarget.classList.contains("hidden")

    if (isHidden) {
      this.errorRowTarget.classList.remove("hidden")
      if (this.hasChevronTarget) this.chevronTarget.classList.add("rotate-180")
    } else {
      this.errorRowTarget.classList.add("hidden")
      if (this.hasChevronTarget) this.chevronTarget.classList.remove("rotate-180")
    }
  }
}
